import Facet from '../Facet';

export default Facet;
